import { createContext, ReactNode, useContext } from 'react';

type TMobileSignupNavContext = {
  goNext: () => void;
};

const MobileSignupNavContext = createContext<TMobileSignupNavContext | null>(
  null,
);

export const MobileSignupNavProvider = ({
  goNext,
  children,
}: TMobileSignupNavContext & { children: ReactNode }) => (
  <MobileSignupNavContext.Provider value={{ goNext }}>
    {children}
  </MobileSignupNavContext.Provider>
);

export const useMobileSignupNavContext = (): TMobileSignupNavContext => {
  const context = useContext(MobileSignupNavContext);
  if (!context) {
    throw new Error(
      'useMobileSignupNavContext must be used within a MobileSignupNavProvider',
    );
  }
  return context;
};
